export default __webpack_public_path__ + "static/media/icon-settings.22f6e79f.svg";